/**
 *
 * Asynchronously loads the component for MemberNotes
 *
 */

import TagWidgetSkeleton from '../../../../components/common/skeletons/TagWidgetSkeleton';
import loadable from '../../../../utils/loadable';

export default loadable(() => import('./index'), {
  fallback: TagWidgetSkeleton,
});
